import { asyncRouterMap } from '@/router'
import { oauthLogout } from '@/utils/oauth'
import Vue from 'vue'

export default {
  namespaced: true,
  state:{
    userInfo: {},
    isLocal:true,//是否为本地登录 true:本地登录 false:crm单点登录
    auth:[],//用户路由权限列表
    token:"",
    allRouter:[],//所有路由
    nowRouter:{},//
    getbutton(buttonshow){
      // let state=$vue.$store.state.userinfo;
      // let isbutton=false;
      // if(state.userInfo.role.isRoot=="Y") {
      //   isbutton=true;
      // }else{
      //   state.userInfo.auth.map(item=>{
      //     if(item.key==$vue.$route.path){
      //       item.children.map(itemName=>{
      //         if(itemName.key==buttonshow){
      //           isbutton=true;
      //         }
      //       })
      //     }
      //   });
      // }
      // return isbutton;
      return true;
    },
    /**新增**/
    currentPage: window.sessionStorage.getItem("currentPage") ? window.sessionStorage.getItem("currentPage") : "",//当前顶部导航下标
    activeRoute: "dashboard",
  },
  //异步触发
  actions:{
    loginBySso({ commit }, data) {  
      return new Promise((resolve, reject) => {
        try {
          commit('setToken', data.access_token)
          window.localStorage.setItem("token", data.access_token)
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    getUserInfoBySso({ state, commit }, data) {
      return Vue.prototype.$post(`${Vue.prototype.config.interface1}login/getLoginUserInfo`).then(res => {
        if (res.code == 200) {
          const data = {
            auth: res.data.menu || [],
            mark: res.data.mark,
            mediaToken: res.data.mediaToken,
            role: {
              isRoot: res.data.roles.length > 0 ? res.data.roles[0].isRoot === 1 ? 'Y' : 'N' : 'N',
              roleId: res.data.roles.length > 0 ? res.data.roles[0].roleId : '',
              roleName: res.data.roles.length > 0 ? res.data.roles[0].roleName : '',
              roleList: res.data.roles.length > 0 ? res.data.roles : []                        
            },
            token: state.token,
            user: {
              userId: res.data.id,
              userName: res.data.nickname,
              mobile: res.data.phone,
            },
            serviceUserId: res.data.serviceUserId
          }
          commit('getUserInfo', { userInfo: data });
          commit('getmeun');
        }
      })
    },
    LoginByUsername({commit,dispatch},userInfo,){
      commit('setSystemFrom',true)
      return $vue.$post(`${$vue.config.interface}login/login`,userInfo)
        .then(res=>{
          if(res.code==200 && !res.data ){
            commit('getUserInfo', res);
            commit('getmeun');
          }
          return res;
        }).catch(res=>{
          return res;
        })
    },
  },
  //处理结果或计算
  mutations:{
    setToken(state, token) {
      state.token = token
    },
    getToken(state) {
      return state.token
    },
    getbutton(state,buttonshow){
      let isbutton=false;
      if(state.userInfo.role.isRoot=="Y") {
        isbutton=true;
      }else{
        state.userInfo.auth.map(item=>{
          if(item.key==$vue.$route.path){
            item.children.map(itemName=>{
              if(itemName.key==buttonshow){
                isbutton=true;
              }
            })

          }
        });
      }
      return isbutton;
    },
    getmeun(state){
      if(state.token!=""){
        let auth = state.userInfo ? state.userInfo.auth : [];
        let arr=asyncRouterMap.indexRoute.concat(asyncRouterMap.nurserRoute);
        for(var i=0;i<arr.length;i++){
          var item=arr[i].children;//路由长度
          for(var j=0;j<item.length;j++){
            var itemName=item[j];
            for(var z=0;z<auth.length;z++){
              var authName=auth[z];
              if(itemName.name==authName.rightName){
                itemName.sop=authName;
                itemName.sopauth=authName.children;
              }
            }
          }
        }
        state.allRouter=arr;
      }

    },//处理权限
    getnowRouter(state,router){
      let newRouter={};
      state.allRouter.map(item=>{
        item.children.map(itemName=>{
          if(itemName.path==router){
            newRouter=itemName;
          }
        })
      });
      state.nowRouter=newRouter;
    },
    isLogin(state){
      if(state.token==""){
        window.sessionStorage.setItem("loginpath",$vue.$route.path);
          $vue.$router.push({path:"/login"})
      }
    },
    setSystemFrom(state,type){
      if(type){
        window.localStorage.setItem('loginType','local');
      }else{
        window.localStorage.setItem('loginType','crm');
      }
      state.isLocal=type;
    },
    //获取用户消息
    getUserInfo(state,res){
      if(res){
        state.token = res.userInfo.token;
        state.userInfo = res.userInfo;
        state.auth = res.userInfo.auth;
        // $.cookie("token",res.userInfo.token,{path:"/"});
        window.localStorage.setItem("userinfo",JSON.stringify(res.userInfo));
        window.localStorage.setItem("auth",JSON.stringify(res.userInfo.auth));
        window.localStorage.setItem("token",res.userInfo.token);
      }else{
        if(window.localStorage.getItem("token")){
          state.token= window.localStorage.getItem("token");
          state.userInfo=JSON.parse(localStorage.getItem("userinfo"));
          state.auth=JSON.parse(localStorage.getItem("auth"));
        }
      }
    },  
    //登出
    loginOut(state){
      state.token="";
      state.userInfo={
        isRoot:'N',
          auth:[],
      };
      // $.cookie("token", "", {expires: 0,path:"/"});
      window.localStorage.removeItem("userinfo");
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("auth");
      window.sessionStorage.removeItem("currentPage")
      state.currentPage = ""
      window.sessionStorage.setItem("loginpath",$vue.$route.path);
      console.log('当前登录方式：手动本地登录');
      window.localStorage.setItem('loginType','local');
      state.isLocal=true;
      $vue.$router.push({path:"/login",query:{local:'1'}});
    },
    logoutBySso(state) {
      state.token = ""
      state.userInfo = {}
      state.auth = []  
      state.currentPage = ""
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("userinfo");
      window.localStorage.removeItem("auth");
      window.sessionStorage.removeItem("currentPage")  
      window.sessionStorage.setItem("loginpath", $vue.$route.path);
      console.log('当前登录方式：手动本地登录');
      window.localStorage.setItem('loginType', 'local');
      state.isLocal = true;
      oauthLogout()
    },
    //更新token
    setHttpToken(state,token){
      window.localStorage.setItem("token",token);
      state.token=token;
    },
    //更改当前页面
    changeCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
      window.sessionStorage.setItem('currentPage', currentPage)
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/userinfo/userinfo.js